const input = {
    username: 'Utilizador',
    password: 'Palavra-passe',
    email: 'Email',
    phone_number: 'Telefone',
    student_number: 'Número de estudante',
    registration_number: 'Número de registo',
    student_identifier_legend: 'Iniciar sessão com',
    confirm_password: 'Confirmar palavra-passe',
    search_region_code: 'Procurar código de região',
    backup_code: 'Código de backup',
    code: 'Código',
    label_with_optional: '{{label}} (Opcional)',
};
export default Object.freeze(input);
